import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import '../styles/SocialLink.css';
import { track } from '../lib/analytics';

const SocialLink = ({
  variant = 'section',
  activeSection,
  id,
  position,
  icon,
  imageUrl,
  title,
  link,
  backgroundColor,
}) => {
  const handleClick = () => {
    track('social_link_click', {
      surface: variant === 'hero' ? 'social_links_hero' : 'social_links_section',
      active_section: activeSection,
      variant,
      social_link_id: id,
      // Backwards-compatible alias.
      social_network: title,
      social_title: title,
      link_url: link,
      position,
    });
  };
  return (
    <a
      href={link}
      target="_blank"
      rel="noreferrer"
      className={`social-link ${variant === 'hero' ? 'is-hero' : ''}`}
      onClick={handleClick}  // Trigger the click tracking
      aria-label={title}
      title={title}
    >
      <div
        className="social-icon-container"
        style={variant === 'hero' ? undefined : { backgroundColor }} // Apply background color to the bubble
      >
        {icon ? (
          <FontAwesomeIcon icon={icon} className="social-icon" />  // Render FontAwesome icon
        ) : (
          <img src={imageUrl} alt={title} className="social-icon" />  // Render image if no icon is provided
        )}
      </div>
    </a>
  );
};

export default SocialLink;
